module.exports = __webpack_public_path__ + "static/media/kh.747d7042.svg";